(() => {
  const initFitGuides = (scope = document) => {
    scope.querySelectorAll('[data-optical-fit-guide-dialog]:not([data-optical-fit-guide-bound])').forEach((dialog) => {
      dialog.dataset.opticalFitGuideBound = 'true';
      const opener = document.querySelector(`[data-optical-fit-guide-open][aria-controls="${dialog.id}"]`);
      const closer = dialog.querySelector('[data-optical-fit-guide-close]');
      let returnFocus = null;

      const open = () => {
        returnFocus = document.activeElement;
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
        closer?.focus();
        window.dataLayer?.push({ event: 'optical_frame_fit_guide_open' });
      };

      const close = () => {
        if (typeof dialog.close === 'function' && dialog.open) dialog.close();
      };

      opener?.addEventListener('click', open);

      closer?.addEventListener('click', close);
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) close();
      });
      dialog.addEventListener('close', () => {
        if (returnFocus instanceof HTMLElement) returnFocus.focus();
      });
      dialog.addEventListener('cancel', () => {
        window.dataLayer?.push({ event: 'optical_frame_fit_guide_close' });
      });

      if (new URLSearchParams(window.location.search).get('frame_fit_guide') === '1') {
        window.requestAnimationFrame(open);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initFitGuides());
  } else {
    initFitGuides();
  }

  document.addEventListener('shopify:section:load', (event) => initFitGuides(event.target));
})();
